<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-menu
            left
            bottom
            transition="scale-transition"
            width="300px"
    >
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="pl-6">
                <v-icon>info_outlined</v-icon>
            </v-btn>
        </template>
        <v-card width="300px">
            <v-card-title class="py-0">
                <v-row>
                    <v-col cols="5" class="caption font-weight-bold">{{ $t('name') }}</v-col>
                    <v-col cols="3" class="caption font-weight-bold">{{ $t('quantityCut') }}</v-col>
                    <v-col cols="4" class="caption font-weight-bold">{{ $t('sum') }}</v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row v-for="item in products" :key="item.seller.id">
                    <v-col cols="12" class="font-italic font-weight-bold text-center caption">{{ getSellerName(item.seller.id) }}</v-col>
                    <v-row v-for="product in item.products" :key="product.id" dense>
                        <v-col cols="5" class="px-2 text-truncate">
                            <span class="caption">{{ product.name }}</span>
                        </v-col>
                        <v-col cols="3" class="px-2 text-center">
                            <span class="caption">{{ product.quantity }}</span>
                        </v-col>
                        <v-col cols="4" class="px-2 text-center">
                            <span class="caption">{{ product.price.toFixed(2) }}</span>
                        </v-col>
                    </v-row>
                </v-row>
            </v-card-text>
            <v-card-text>
                <v-row>
                    <v-col cols="6" class="font-weight-bold">{{ $t('toPay') }}</v-col>
                    <v-col cols="6" class="text-right">{{ `${totalPrice.toFixed(2)} ${currency}` }}</v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
    import DataProvider from '../../../../app-front/mixins/OrderDataProvider';

    export default {
        name: "OrderDialogProducts",
        mixins: [
            DataProvider
        ],
        data() {
            return {
                products: [],
                totalPrice: 0
            }
        },
        computed: {
            currency() {
                return this.$store.state.currency[0].name.toUpperCase();
            }
        },
        methods: {
            getProductData(sellerID) {
                const seller = this.inProcessProducts.find(item => item.sellerID === sellerID);

                if(!seller) return false;

                const inProcessProducts = seller.products.filter(item => item.quantity && item.calculatedPrice);
                const sellerProductsData = this.orderProducts.find(item => item.seller.id === sellerID);

                if(!inProcessProducts.length || !sellerProductsData) return false;

                const orderSellerProductData = {
                    seller: sellerProductsData.seller,
                    products: []
                };

                inProcessProducts.forEach(item => {
                    const productData = sellerProductsData.data.find(product => product.id === item.id);

                    if(!productData) return false;

                    const data = {};

                    let quantity = item.quantity;

                    if(productData.pack) {
                        quantity *= productData.pack.value;

                        if(productData.pack.minValue) quantity *= productData.pack.minValue;

                        quantity += ` ${productData.pack.unitName}`;
                    }

                    data.id = item.id;
                    data.name = productData.productName;
                    data.price = seller.totalDiscount ? item.calculatedPrice * (1 - seller.totalDiscount / 100) : item.calculatedPrice;
                    data.quantity = quantity;
                    this.totalPrice += data.price;

                    orderSellerProductData.products.push(data);
                });

                return orderSellerProductData;
            },
            setProducts() {
                const orderProducts = [];
                this.totalPrice = 0;

                this.dialogSellers.map(sellerID => {
                    const data = this.getProductData(sellerID);

                    if(data) orderProducts.push(data);
                });

                this.products = orderProducts;
            }
        },
        created() {
            this.setProducts();
        },
        watch: {
            dialogSellers: {
                handler() {
                    this.setProducts();
                },
                deep: true
            }
        }
    }
</script>
